/**
 * One headline number with its label and a line of context: cost per founder, the monthly total. Sentence-case
 * label, the value in the sans (proportional figures), the context muted. `hero` for the one number a view leads with.
 */
import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './StatTile.module.css'

export function StatTile({ label, value, sub, hero, tone = 'default' }: { label: string; value: string; sub?: ReactNode; hero?: boolean; /** `accent` marks a good outcome (a margin), `down` a loss. Never alone: the words say it too. */ tone?: 'default' | 'accent' | 'down' }) {
  return (
    <div className={cx(s.tile, hero && s.hero)}>
      <span className={s.label}>{label}</span>
      <span className={cx(s.value, s[tone])}>{value}</span>
      {sub && <span className={s.sub}>{sub}</span>}
    </div>
  )
}
